import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import DeleteModal from 'pages/parts/DeleteModal'
import { returnSign, findKeyFromArrayByValue, notify } from "helpers/helpers";
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({})
	const [selectedItem, setSelectedItem] = useState({})
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [halls, setHalls] = useState([])
	const [poses, setPoses] = useState([])
	const [products, setProducts] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [showLoopModal, setShowLoopModal] = useState(false)
	const [showMassModal, setShowMassModal] = useState(false)
	const [selectedHallIds, setSelectedHallIds] = useState([])
	const [massServicePercentage, setMassServicePercentage] = useState('')
	const [massDeleteConfirm, setMassDeleteConfirm] = useState(false)
	const [loopData, setlLoopData] = useState({
		'number_start': '',
		'number_end': '',
		'hall_id': '',
		'suffix': '',
		'guest_count': '',
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			pos_id: reduxAccount.pos_id,
			search: '',
		},
		initialPagination: {
			url: '/tables',
			response: null
		},
	})

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		if (selectedItem.id) {
			response = await PUT('/tables', selectedItem, { loader: true })
		} else {
			response = await POST('/tables', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	async function toggleModal(bool = false, item = {}) {
		if (!products.length) {
			const response = await GET('/products-list', {}, { loader: true })
			if (httpOk(response)) setProducts(response.data)
		}

		setSelectedItem(item)
		setShowModal(bool)
	}

	function openMassModal() {
		setSelectedHallIds([])
		setMassServicePercentage('')
		setMassDeleteConfirm(false)
		setShowMassModal(true)
	}

	function toggleHallSelection(hallId) {
		setSelectedHallIds((prev) => (
			prev.includes(hallId)
				? prev.filter((id) => id !== hallId)
				: [...prev, hallId]
		))
	}

	function toggleSelectAllHalls() {
		if (selectedHallIds.length === halls.length) {
			setSelectedHallIds([])
			return
		}
		setSelectedHallIds(halls.map((hall) => hall.id))
	}

	async function applyMassServicePercentage(e) {
		e.preventDefault()
		if (!selectedHallIds.length) {
			notify(t('select_halls'), 'error')
			return
		}
		if (massServicePercentage === '' || massServicePercentage == null) {
			notify(t('percent_service'), 'error')
			return
		}

		const response = await PUT('/halls-change-percentage', {
			hall_ids: selectedHallIds,
			service_percentage: massServicePercentage,
		}, { loader: true })

		if (httpOk(response)) {
			notify(t('success'), 'success')
			setShowMassModal(false)
			searchWithFilter()
		}
	}

	async function deleteTablesBySelectedHalls() {
		if (!selectedHallIds.length) {
			notify(t('select_halls'), 'error')
			return
		}

		const response = await POST('/tables-delete-by-halls', {
			hall_ids: selectedHallIds,
		}, { loader: true })

		if (httpOk(response)) {
			notify(t('success'), 'success')
			setMassDeleteConfirm(false)
			setShowMassModal(false)
			searchWithFilter()
		}
	}

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/tables"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.hall_id)
			urlParams += returnSign(urlParams) + 'hall_id=' + filterDataCopy.hall_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/tables${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		const responseHalls = await GET(`/helper/halls${urlParams}`, {}, { loader: true })
		if (httpOk(response) && httpOk(responseHalls)) {
			setHalls(responseHalls.data)
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		resetFilters({
			pos_id: null,
			search: '',
		}, (nextFilterData) => searchWithFilter({ filterData: nextFilterData }))
	}

	function checkFilter(currentFilterData) {
		if (
			currentFilterData.pos_id === null &&
			!currentFilterData.page &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ filterData: { ...filterData, page } })
	}

	async function deleteItem() {
		const response = await DELETE('/tables', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function createLoop(e) {
		e.preventDefault();
		await POST('/tables-several', loopData, { loader: true })

		setShowLoopModal(false)
		searchWithFilter()
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) {
			setPoses(response.data)
		}
	}

	useEffect(() => {
		getPoses()
	searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('tables')} [{data.total}]
				</h4>
				<div className="d-flex gap-3">
					<button className="btn-rounded btn btn-outline-primary"
						onClick={openMassModal}>
						<i className="uil uil-check-square"></i>
						{t('mass_actions')}
					</button>
					<button className="btn-rounded btn btn-primary"
						onClick={() => setShowLoopModal(true)}>
						<i className="uil uil-plus"></i>
						{t('create_several')}
					</button>
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('halls')}</label>
												<Select
													options={halls}
													value={halls.find(option => option.id === filterData.hall_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'hall_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('hall')}</th>
									<th style={{ 'width': '15%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('number_of_guests')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('service')}</th>
									<th style={{ 'width': '60%' }}>{t('product')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.hall_name}</td>
										<td className="td-ellipsis">
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="text-end">{item.guest_count}</td>
										<td className="text-end">{item.service_percentage}%</td>
										<td>{item.product_name}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{item.status > 0 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL CREATE UPDATE */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>№ {t('table')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('percent_service')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="service_percentage"
									value={selectedItem.service_percentage}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'service_percentage': e.target.value })} />
							</div>
						</div>
						<div className="form-group">
							<label>{t('number_of_guests')}</label>
							<input type="number" className="form-control" name="guest_count"
								value={selectedItem.guest_count ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'guest_count': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('hall')}<span className="required-mark">*</span></label>
							<Select
								options={halls}
								value={halls.find(option => option.id === selectedItem.hall_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'hall_id': option.id, 'pos_id': option.pos_id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{selectedItem.id &&
							<div className="form-group">
								<label>{t('auto_add_products')}</label>
								<Select
									isClearable
									options={products}
									value={products.find(option => option.product_id === selectedItem.product_id)}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'product_id': option ? option.product_id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.product_id}
								/>
							</div>
						}
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE */}

			{/* MODAL LOOP */}
			<Modal show={showLoopModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setShowLoopModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('create')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createLoop(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('from')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="number_start"
								onChange={(e) => setlLoopData({ ...loopData, 'number_start': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('to')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="number_end"
								onChange={(e) => setlLoopData({ ...loopData, 'number_end': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('percent_service')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="service_percentage"
								onChange={(e) => setlLoopData({ ...loopData, 'service_percentage': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('number_of_guests')}</label>
							<input type="number" className="form-control" name="guest_count"
								value={loopData.guest_count}
								onChange={(e) => setlLoopData({ ...loopData, 'guest_count': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('hall')}<span className="required-mark">*</span></label>
							<Select
								options={halls}
								value={halls.find(option => option.id === loopData.hall_id)}
								onChange={(option) => setlLoopData({ ...loopData, 'hall_id': option.id, 'pos_id': option.pos_id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={() => setShowLoopModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!loopData.number_start || !loopData.number_end || !loopData.hall_id || !loopData.guest_count}>{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL LOOP */}

			{/* MODAL MASS ACTIONS */}
			<Modal show={showMassModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setShowMassModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('mass_actions')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={applyMassServicePercentage} autoComplete="off">
						<div className="d-flex justify-content-between align-items-center mb-2">
							<label className="mb-0">{t('select_halls')}</label>
							<button type="button" className="btn btn-sm btn-outline-primary"
								onClick={toggleSelectAllHalls}
								disabled={!halls.length}>
								{selectedHallIds.length === halls.length && halls.length > 0
									? t('reset')
									: t('select_all')}
							</button>
						</div>
						<div className="border rounded p-2 mb-3" style={{ maxHeight: '220px', overflowY: 'auto' }}>
							{!halls.length &&
								<div className="text-muted small">{t('list_empty')}</div>
							}
							{halls.map((hall) => (
								<label key={hall.id} className="d-flex align-items-center gap-2 mb-2">
									<input
										type="checkbox"
										className="form-check-input m-0"
										checked={selectedHallIds.includes(hall.id)}
										onChange={() => toggleHallSelection(hall.id)}
									/>
									<span>{hall.name}</span>
								</label>
							))}
						</div>

						<div className="form-group">
							<label>{t('percent_service')}<span className="required-mark">*</span></label>
							<input
								type="number"
								min="0"
								max="40"
								step="0.01"
								className="form-control"
								value={massServicePercentage}
								onChange={(e) => setMassServicePercentage(e.target.value)}
							/>
						</div>

						<button type="submit" className="btn btn-primary w-100 mb-2"
							disabled={!selectedHallIds.length || massServicePercentage === ''}>
							{t('change_hall_service_percentage')}
						</button>

						<button type="button" className="btn btn-outline-danger w-100"
							disabled={!selectedHallIds.length}
							onClick={() => setMassDeleteConfirm(true)}>
							{t('delete_tables_of_selected_halls')}
						</button>

						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setShowMassModal(false)}>
								{t('cancel')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL MASS ACTIONS */}

			<Modal show={massDeleteConfirm} animation={false} centered
				onHide={() => setMassDeleteConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('delete')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="mb-3">{t('are_you_sure_delete_tables_of_halls')}</p>
					<div className="d-flex gap-2">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setMassDeleteConfirm(false)}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-danger w-100"
							onClick={deleteTablesBySelectedHalls}>
							{t('delete')}
						</button>
					</div>
				</Modal.Body>
			</Modal>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
